import { render } from "./Slideshow.vue?vue&type=template&id=5b133823&scoped=true"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"

import "./Slideshow.vue?vue&type=style&index=0&id=5b133823&lang=scss"
import "./Slideshow.vue?vue&type=style&index=1&id=5b133823&lang=scss&scoped=true"
import "./Slideshow.vue?vue&type=style&index=2&id=5b133823&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b133823"]])

export default __exports__